import defaultShadows, { Shadows } from "@mui/material/styles/shadows"

export const customShadows: Shadows = [...defaultShadows]

customShadows[1] =
  "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)"
